import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBashgaLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width={32}
    height={32}
    fill='none'
    {...props}
  >
    <rect width={31} height={31} x={0.5} y={0.5} fill='#fff' rx={11.5} />
    <rect width={31} height={31} x={0.5} y={0.5} fill='url(#bashgaLogo_svg__a)' rx={11.5} />
    <rect width={31} height={31} x={0.5} y={0.5} stroke='#E0E3EB' rx={11.5} />
    <defs>
      <pattern id='bashgaLogo_svg__a' width={1} height={1} patternContentUnits='objectBoundingBox'>
        <use xlinkHref='#bashgaLogo_svg__b' transform='scale(.03571)' />
      </pattern>
      <image
        xlinkHref='/images/icons/bashga-logo-24574573.webp'
        id='bashgaLogo_svg__b'
        width={28}
        height={28}
      />
    </defs>
  </svg>
);
export default SvgBashgaLogo;
